import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { FlexCenterWrapper } from 'wrappers';
import internalState from './internalState';
import { csvData, exportFileName } from './utils';
import ExportDropdown from '../exportDropdown';

export const definition = {
  name: 'ExportMakeReadyCards',
  controller: Controller,
  initialProps: ({
    cards,
    status,
    archived,
    properties,
    selectedPropertyIds,
    groups,
    selectedGroupIds,
    view,
    calendarSelectedDate,
    makeReadyCategories,
    selectedFloorplanIds,
    selectedTagIds,
    floorPlans,
    noTagIds,
    startMoveOutDate,
    startMoveInDate,
    endMoveOutDate,
    endMoveInDate,
    cardCounts
  }) => ({
    cards,
    status,
    archived,
    properties,
    selectedPropertyIds,
    groups,
    selectedGroupIds,
    view,
    calendarSelectedDate,
    makeReadyCategories,
    selectedFloorplanIds,
    selectedTagIds,
    floorPlans,
    noTagIds,
    startMoveOutDate,
    startMoveInDate,
    endMoveOutDate,
    endMoveInDate,
    cardCounts
  }),
  props: internalState,
  elements: [
    {
      component: ExportDropdown,
      name: 'ExportDropdown',
      bindings: ({ cards, status, archived, properties, selectedPropertyIds, groups, selectedGroupIds, view, calendarSelectedDate, makeReadyCategories, selectedFloorplanIds,
        selectedTagIds,
        floorPlans,
        noTagIds,
        startMoveOutDate,
        startMoveInDate,
        endMoveOutDate,
        endMoveInDate,
        cardCounts }) =>
      ({
        cards, status, archived, properties, selectedPropertyIds, groups, selectedGroupIds, view, calendarSelectedDate, makeReadyCategories,
        csvData: csvData({ cards, makeReadyCategories }),
        fileName: exportFileName({ status }),
        showSubscribe: true,
        subscribeComingSoon: false,
        selectedFloorplanIds,
        selectedTagIds,
        floorPlans,
        noTagIds,
        startMoveOutDate,
        startMoveInDate,
        endMoveOutDate,
        endMoveInDate,
        cardCounts
      })
    }
  ]
}
export default wrap(ContainerComponent(definition), FlexCenterWrapper);